import type React from 'react';
import {
  type CSSProperties,
  type PropsWithChildren,
  PureComponent,
  type ReactNode,
} from 'react';

import classNames from 'classnames';

import { ui } from '../../utils/helpers';

import styles from './tooltip.module.css';

type Props = PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
  id?: string;
  placement: 'bottom' | 'top' | 'right' | 'left';
  fixed?: boolean;
  align?: boolean;
  elRef?: React.RefObject<HTMLDivElement | null>;
}>;

class Tooltip extends PureComponent<Props> {
  static defaultProps = {
    placement: 'top',
  };

  onClick(event: React.MouseEvent<HTMLDivElement>): void {
    event.stopPropagation();
    event.preventDefault();
  }

  render(): ReactNode {
    const { className, children, style, id, placement, fixed, align, elRef } =
      this.props;
    return (
      <div
        role="tooltip"
        {...ui('tooltip')}
        onClick={this.onClick}
        ref={elRef}
        className={classNames(
          className,
          styles.root,
          styles[placement],
          fixed ? styles.fixed : undefined,
          align ? styles.align : undefined,
        )}
        id={id}
        style={style}
      >
        {children}
      </div>
    );
  }
}

export default Tooltip;
